import './theme/assets/sass/style.react.scss';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AuthProvider } from './app/modules/auth';
import { AppRoutes } from './app/routing/AppRoutes';
import setupAxios from './app/services/axios';
import './app/styles/index.scss';
// Apps

/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './theme/assets/css/style.rtl.css'
 **/
import './theme/assets/sass/plugins.scss';
import './theme/assets/sass/style.scss';
import { MetronicI18nProvider } from './theme/i18n/Metronici18n';
import { ThemeModeProvider } from './theme/partials/layout/theme-mode/ThemeModeProvider';

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios();

const queryClient = new QueryClient();
const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <ThemeModeProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </ThemeModeProvider>
      </MetronicI18nProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>,
  );
}
